module.exports = __webpack_public_path__ + "media/5.b5a114a6.wav";